export class CancelPromiseError extends Error {
  constructor () {
    super('Cancel')
  }
}
